import { Core, Decorative } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web/common/localization/localize";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { Section } from "@faire/retailer/views/careers/__internal__/common/common";
import { extendedMediaStrings } from "@faire/retailer/views/careers/__internal__/common/media";

export const ValuePropositionSection = () => {
  const { isMobile, isDesktopAndAbove } = useViewport();
  return (
    <CustomSection>
      <Typography
        color={Core.text.inverse}
        align="center"
        variant={{
          xLargeAndAbove: "displayLSerifRegular",
          desktopAndAbove: "displayMSerifRegular",
          mobileAndAbove: "pageHeaderSerifRegular",
        }}
      >
        {isMobile ? (
          <StrictLocalMsg
            // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
            defaultMessage="We believe small businesses{lineBreak}are vital to our communities"
            values={DEPRECATED_backwardsCompatibleValues({ lineBreak: <br /> })}
          />
        ) : (
          <StrictLocalMsg
            // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
            defaultMessage="We believe small businesses are{lineBreak}vital to our communities"
            values={DEPRECATED_backwardsCompatibleValues({ lineBreak: <br /> })}
          />
        )}
      </Typography>
      <Spacer size={isDesktopAndAbove ? "3x" : "2x"} />
      <Typography
        align="center"
        color={Core.text.inverse}
        variant={{
          desktopAndAbove: "subheadingSansRegular",
          mobileAndAbove: "paragraphSansRegular",
        }}
      >
        {isMobile ? (
          <StrictLocalMsg
            // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
            defaultMessage="It’s why we come to work every day—{lineBreak}to help independent shopkeepers,{lineBreak}makers, and artisans across the globe{lineBreak}build thriving and successful businesses."
            values={DEPRECATED_backwardsCompatibleValues({ lineBreak: <br /> })}
          />
        ) : (
          <StrictLocalMsg
            // eslint-disable-next-line @faire/no-mid-sentence-linebreaks
            defaultMessage="It’s why we come to work every day—to help{lineBreak}independent shopkeepers, makers, and artisans across{lineBreak}the globe build thriving and successful businesses."
            values={DEPRECATED_backwardsCompatibleValues({ lineBreak: <br /> })}
          />
        )}
      </Typography>
    </CustomSection>
  );
};

const CustomSection = styled(Section).attrs({
  align: "center",
  justify: "center",
  $withHorizontalPadding: true,
  $withVerticalPadding: true,
  $backgroundColor: Decorative.shade.yellow,
})`
  ${responsiveMediaQueries.desktop},
  ${extendedMediaStrings.xlarge} {
    padding-top: 104px;
    padding-bottom: 104px;
  }
`;
